import * as React from 'react';
import { AlertsTypes, ChatMessage } from '_helpers';
import moment from 'moment';
import cn from 'classnames';

import styles from './OnlineChat.module.scss';

const OnlineChatAlert: React.FC<IProps> = ({ message }) => (
  <div className={styles.chat_field}>
      <div className={cn(styles.chat_field_body, styles.alert)}>
          <span className={styles.chat_userName} style={{ color: `var(${AlertsTypes[message.type].color})` }}>
              {AlertsTypes[message.type].text}
          </span>
          <span className="d-block">
              {message.message}
          </span>
          <span className={styles.messageTime}>
              {moment(message.created).format('HH:mm:ss')}
          </span>
      </div>
  </div>
);

interface IProps {
    message: ChatMessage;
}

export default OnlineChatAlert;
